export const reservasModals = {
  roomChange: {
    close: "Chiudi",
    titleAssign: "Assegna camera",
    titleChange: "Cambia camera",
    stopSoldNote:
      "Questo tipo di camera è chiuso alla vendita in queste date (stop-sell), ma puoi comunque riorganizzare le camere: spostare o assegnare non riaprirà le vendite.",
    labelAssign: "Camera da assegnare",
    labelNew: "Nuova camera",
    selectPlaceholder: "Seleziona una camera…",
    swapWith: "Scambia con {names}",
    swapWithType: "Scambia con {names} (passa a {type})",
    swapTypeWarning: "Con lo scambio, {names} passa a {type}, che non è la tipologia prenotata.",
    swapGroup:
      "Scambio di gruppo: {name} e {also} si spostano in quella camera e {incoming} si spostano nella tua. Tutto in un'unica operazione.",
    swapSingle:
      "Quella camera è occupata da {names}. Al salvataggio verranno {action}: la tua prenotazione si sposta in quella camera e le altre nella tua.",
    swapWord: "scambiati",
    emptyNote:
      "Nessuna camera è libera per l'intero periodo. Usa il pulsante {action} nella corsia «Da organizzare» per riorganizzare le prenotazioni automaticamente.",
    organizeWord: "Organizza",
    sameTypeGroup: "Stesso tipo · {name}",
    otherTypeGroup: "Altro tipo · {name}",
    typeChangeNote:
      "La prenotazione passerà a {type}. La scheda si aggiorna, la disponibilità dei due tipi si ricalcola e i canali vengono avvisati.",
    selectRoomError: "Devi selezionare una camera",
    cancel: "Annulla",
    confirmSwap: "Scambia",
    confirmAssign: "Assegna",
    confirmSave: "Salva modifica",
  },
  outOfOrder: {
    titleMaintenance: "Manutenzione camera",
    titleActions: "Azioni per tipo di camera",
    scopeLabel: "Ambito",
    scopeUnit: "Tipo di camera (tutte)",
    scopeInstance: "Questa camera",
    actionLabel: "Azione",
    actionOoo: "Fuori servizio (manutenzione)",
    actionOpen: "Riapri nel periodo",
    quantityLabel: "Numero di camere",
    maxPerDay: "Fino a {max} al giorno.",
    dateRangeLabel: "Intervallo di date",
    from: "Da",
    to: "A",
    cancel: "Annulla",
    apply: "Applica",
  },
  closeDay: {
    title: "Modifica disponibilità",
    syncing: "Sincronizzazione disponibilità...",
    roomTypeLabel: "Tipo di camera",
    roomTypePlaceholder: "Seleziona una camera",
    startDate: "Data di inizio",
    endDate: "Data di fine",
    maxAvailable: "Massimo: {count} disponibili",
    cancel: "Annulla",
    apply: "Applica modifica",
  },
  confirm: {
    defaultTitle: "Confermare?",
    confirm: "Conferma",
    cancel: "Annulla",
  },
  updateAlert: {
    title: "Aggiorna camera",
    sectionTitle: "Informazioni sulla camera",
    nameLabel: "Nome o numero della camera",
    keyLabel: "Chiave di accesso",
    cancel: "Annulla",
    submit: "Aggiorna camera",
    nameRequired: "Il nome o numero della camera è obbligatorio",
  },
};
